<template>
  <v-dialog v-model="dialog" persistent width="800px">
    <v-card>
      <v-card-title class="primary white--text">
        <v-toolbar-title class="text-uppercase">Sửa trả lời của học sinh</v-toolbar-title>
        <v-spacer />
        <v-icon color="white" @click="closePopup">close</v-icon>
      </v-card-title>
      <v-card-text>
        <div class="d-flex">
          <div class="py-2 mr-2">Học sinh được áp dụng:</div>
          <CardStudentName :student="item.student" link />
        </div>
        <div>
          <QuestionView
            v-for="(question, index) in questions"
            :key="question.id"
            :index="index + 1"
            :question="question"
            :answers="getOriginAnswerForQuestion(question)"
            class="mb-3"
            ref="question-views"
          />
        </div>
      </v-card-text>
      <v-divider />
      <v-card-actions class="d-flex justify-space-between pa-4">
        <v-btn class="px-6" outlined light depressed @click="closePopup">Huỷ</v-btn>
        <v-spacer />
        <v-btn color="primary" width="100px" class="elevation-0" @click="onSubmit">Xác nhận</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { cloneDeep, get } from 'lodash'
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import QuestionView from './QuestionView.vue'
export default {
  components: { CardStudentName, QuestionView },
  data: () => ({ dialog: false, item: {} }),
  computed: {
    ...mapGetters({ questions: 'surveyQuestion/items' }),
  },
  methods: {
    ...mapActions({ update: 'studentSurvey/update', search: 'studentSurvey/search' }),
    openPopup(item) {
      this.item = item
      this.answers = cloneDeep(item.answers)
      this.dialog = true
    },
    closePopup() {
      this.dialog = false
      this.reset()
    },
    reset() {
      const refs = this.$refs['question-views']
      if (Array.isArray(refs)) refs.forEach(r => r.reset())
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    getOriginAnswerForQuestion(question = {}) {
      const answers = get(this.item, 'answers', [])
      if (Array.isArray(answers) && answers.length) {
        const answerObj = answers.find(a => a.question === question.id)
        switch (question.type) {
          case 'single':
            return get(answerObj, 'answer', {})
          case 'text':
            return get(answerObj, 'answer', '')
          case 'multiple':
            return get(answerObj, 'answers', [])
          default:
            return null
        }
      }
      return null
    },
    async onSubmit() {
      let answers = []
      const refs = this.$refs['question-views']
      if (Array.isArray(refs)) answers = refs.map(r => r.getData())
      if (Array.isArray(answers) && answers.length) {
        try {
          this.$loading.active = true
          await this.update({ id: this.item.id, answers })
          await this.search({ survey: this.$route.params.id, _sort: 'createdAt:DESC', student: this.item.student.id })
          this.closePopup()
        } catch (error) {
          this.$alert.error(error)
        } finally {
          this.$loading.active = false
        }
      } else {
        this.$alert.error('Vui lòng chọn câu trả lời')
      }
    },
  },
}
</script>
